/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'extension.charts.aggregateData': 'Samla data',
  'extension.charts.aggregateDataDescription':
    'Kombinera värden till en enda datapunkt när flera rader har samma värde.',
  'extension.charts.category': 'Kategori',
  'extension.charts.customizeTab': 'Anpassa',
  'extension.charts.dataMissing.details': 'Vi hittar inte diagrammets källtabell på sidan.',
  'extension.charts.dataMissing.title': 'Inga data att visa',
  'extension.charts.dataTab': 'Data',
  'extension.charts.defaultColumnName': 'Kolumn {0}',
  'extension.charts.defaultTitle': 'Namnlöst diagram',
  'extension.charts.defaultYLabel': 'Namnlös axel',
  'extension.charts.extensionTitle': 'Diagram',
  'extension.charts.height': 'Diagrammets höjd',
  'extension.charts.height.large': 'Högre',
  'extension.charts.height.medium': 'Standard',
  'extension.charts.height.small': 'Kortare',
  'extension.charts.horizontal.orientation.label': 'Horisontellt',
  'extension.charts.insert.tooltip': 'Infoga diagram',
  'extension.charts.legend': 'Förklaring',
  'extension.charts.legend.auto': 'Auto',
  'extension.charts.legend.bottom': 'Under',
  'extension.charts.legend.left': 'Vänster',
  'extension.charts.legend.position': 'Förklaringens position',
  'extension.charts.legend.right': 'Höger',
  'extension.charts.legend.show': 'Visa förklaring',
  'extension.charts.legend.top': 'Över',
  'extension.charts.options.label': 'Diagramalternativ',
  'extension.charts.options.tooltip': 'Ändra diagramalternativ',
  'extension.charts.orientation.label': 'Riktning',
  'extension.charts.seriesNames': 'Dataserie',
  'extension.charts.showPoints': 'Visa datapunkter',
  'extension.charts.smoothLines': 'Jämna linjer',
  'extension.charts.style': 'Stil',
  'extension.charts.title': 'Titel',
  'extension.charts.type.bar': 'Stapel',
  'extension.charts.type.fieldDescription': 'Diagramtyp',
  'extension.charts.type.line': 'Linje',
  'extension.charts.type.pie': 'Cirkel',
  'extension.charts.userTitle': 'Titel',
  'extension.charts.vertical.orientation.label': 'Vertikalt',
  'extension.charts.xAxis': 'X-axel',
  'extension.charts.xLabel': 'Etikett för X-axel',
  'extension.charts.yLabel': 'Etikett för Y-axel',
};
